
<template>
   <section>
  </section>
</template>

<script>
import auth from '@/auth'
import router from '@/router'

export default {
  name: 'DefaultPage',
  data () {
    return {
      auth: auth
    }
  },
  mounted () {
    if (auth.user.authenticated) {
      if (auth.user.user_role === 'admin') {
        router.replace({name: 'Dashboard'})
      }
      if (auth.user.user_role === 'call') {
        router.replace({name: 'VehicleAdd'})
      }
      if (auth.user.user_role === 'charity') {
        router.replace({name: 'CharityView'})
      }
      if (auth.user.user_role === 'charity_prospect') {
        router.replace({name: 'PreviewAccount'})
      }
    } else {
      router.replace({name: 'Login'})
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/DefaultPage.vue